import React from 'react';
import PropTypes from 'prop-types';
import { Layer, Rectangle } from 'recharts';
import { brandingVariables } from 'smartsuite-ui';
import { colors } from '../../../../shared/constants/constants';
import { getFormattedValue } from '../../../dashboardUtils';

// eslint-disable-next-line complexity
export default function SankeyChartNode(props) {
    return (
        <Layer key={props.index}>
            <Rectangle
                x={props.x}
                y={props.y}
                width={props.width}
                height={props.height}
                fill={colors[props.index % colors.length]}
                fillOpacity="1"
            />
            <text
                x={props.x + props.width + 6}
                y={props.y + props.height / 2}
                fontSize="1rem"
                stroke={brandingVariables.accent5}
            >
                {props.payload.name}
            </text>
            <text
                x={props.x + props.width + 6}
                y={props.y + props.height / 2 + 13}
                fontSize="0.85rem"
                stroke={brandingVariables.accent5}
                strokeOpacity="0.5"
            >
                {getFormattedValue(
                    props.payload.value,
                    props.suffix,
                    props.dataFormatter,
                    props.dataFormat
                )}
            </text>
        </Layer>
    );
}

SankeyChartNode.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    index: PropTypes.number,
    payload: PropTypes.instanceOf(Object),
    dataFormat: PropTypes.string.isRequired,
    dataFormatter: PropTypes.func,
    suffix: PropTypes.string.isRequired,
};

SankeyChartNode.defaultProps = {
    payload: {},
};
